import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AuthShell } from "@/components/layout/AuthShell";
import { Field } from "@/components/shared/Common";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function Login() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ identifier: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const home = location.pathname.startsWith("/terreno") ? "/terreno" : "/";

  if (user) return <Navigate to={location.state?.from || home} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      navigate(data.must_change_password ? "/mi-cuenta" : location.state?.from || home, { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Iniciar sesión" subtitle="Ingrese con su email o nombre de usuario.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field label="Email o usuario">
          <Input data-testid="login-identifier-input" autoComplete="username" value={form.identifier}
            onChange={(e) => setForm({ ...form, identifier: e.target.value })} required className="h-11" />
        </Field>
        <Field label="Contraseña">
          <Input data-testid="login-password-input" type="password" autoComplete="current-password" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })} required className="h-11" />
        </Field>
        {error && <div data-testid="login-error" className="rounded-lg border border-[#f5c2c0] bg-[#fdeaea] px-3 py-2 text-sm text-[#b42318]">{error}</div>}
        <Button data-testid="login-submit-btn" type="submit" disabled={loading} className="w-full h-11 rounded-full text-base">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Ingresar
        </Button>
        <div className="text-center">
          <Link to="/recuperar" data-testid="forgot-password-link" className="text-sm font-semibold text-[#258F00] hover:underline">¿Olvidó su contraseña?</Link>
        </div>
      </form>
    </AuthShell>
  );
}
